﻿import { defineComponent } from 'vue';

import { Product } from '../../../services/product';
import { Booking } from '../../../services/booking';
import { Web_Engine } from "../../../services/web_engine"

import { age_cat } from "../../../objects/v1_3/web_engine/age_cat"

import { Currency_Service } from '../../../../system/services/currency';
import { Date_Service } from '../../../../system/services/date_service';
import { List_Service } from '../../../../system/services/list_processing';
import { createObjectBindingPattern } from 'typescript';
import { room } from '../../../objects/v1_2/Booking/Room';
import { trip_passenger } from '../../../objects/v1_2/Booking/Trip_Passenger';

import { booking_info } from '../../../objects/v1_2/Booking_Details/booking_info';
import { client_booking } from '../../../objects/v1_2/Booking_Details/client_booking';
import { booking_trip_room } from '../../../objects/v1_2/Booking_Details/booking_trip_room';

const Book: Booking = new Booking();
const Prod: Product = new Product();
const Web: Web_Engine = new Web_Engine();
const Currency_Services: Currency_Service = new Currency_Service();
const List_Services: List_Service = new List_Service();

export default defineComponent({
    name: "itinerary_breakdown",
    props: {
        display_open: String,
        // cart: one compact block per tour (subtotal, dates, passengers grouped by price) with its add-ons nested under it
        compact: { type: Boolean, default: false }
    },
    data() {
        return {
            age_cat: new age_cat(),
            isOpen: false
        }
    },
    methods: {
        async download_passenger() {
            const web_engine = new Web_Engine();
            this.age_cat = await web_engine.Get_Passengers();
            this.age_cat.categories = this.age_cat.categories.sort((first, second): number => {
                return 0 - (first.name > second.name ? -1 : 1)
            });
        },
        display_details(): boolean {
            let Return_Value: boolean = false;

            if (this.display_open == "true") {
                Return_Value = false;
            } else {
                Return_Value = !this.isOpen;
            }

            return Return_Value;
        },
        get_Trips(): booking_info[]  {
            let Trips: booking_info[] = [];

            this.$store.getters.get_Booking?.trips?.forEach((Trip:booking_info) => {
                Trips.push(Trip);
            });

            return Trips;
        },
        product_name(Trip: booking_info): string {
            return Prod.Get_Details_Sync(Trip?.tour_id, this.$store).name;
        },
        getRef(): string {
            return this.$store.getters.get_Booking?.group_booking_id;
        },
        product_duration(Trip: booking_info): string {
            return Prod.product_duration_information(Prod.Get_Details_Sync(Trip?.tour_id, this.$store));
        },
        durationInDays(Trip: booking_info): string {
            let return_value: string = Prod.product_durationInDays(Prod.Get_Details_Sync(Trip?.tour_id, this.$store));
            if (return_value == "0 days") {
                return_value = "";
            }
            return return_value;
        },
        isAAT(): boolean {
            if (import.meta.env.VITE_DEFAULT_PARENT == "AAT") {
                return true;
            }
            return false;
        },
        product_overnight_duration(Trip: booking_info): string {
            return Prod.product_overnight_duration(Prod.Get_Details_Sync(Trip?.tour_id, this.$store));
        },
        // true when a day tour's times are unknown: the end time comes out as "0:0" (or NaN). Must match a standalone "0:0":
        // a plain includes("0:0") also matched normal times such as 09:30:00 or 10:00, which hid those tours' dates.
        product_check_dates(Trip: booking_info): boolean {
            const text = Prod.trip_starts_ends(Trip?.departure_date, Prod.Get_Details_Sync(Trip?.tour_id, this.$store));
            return /(^|[^0-9])0:0($|[^0-9])/.test(text) || text.includes("NaN");
        },
        product_start_date(Trip: booking_info): string {
            return this.DateTrim(Prod.trip_starts(Trip?.departure_date, Prod.Get_Details_Sync(Trip?.tour_id, this.$store)));
        },
        product_start_date_Only(Trip: booking_info): string {
            return Prod.trip_starts_date(Trip?.departure_date);
        },
        product_start_end_date(Trip: booking_info): string {
            return this.DateTrim(Prod.trip_starts_ends(Trip?.departure_date, Prod.Get_Details_Sync(Trip?.tour_id, this.$store)));
        },
        product_end_date(Trip: booking_info): string {
            return this.DateTrim(Prod.trip_ends(Trip?.departure_date, Prod.Get_Details_Sync(Trip?.tour_id, this.$store)));
        },
        product_end_date_only(Trip: booking_info): string {
            return Prod.trip_ends_date(Trip?.departure_date, Prod.Get_Details_Sync(Trip?.tour_id, this.$store));
        },
        passenger_total(): string {
            if (this.$store.getters.get_Booking?.passengers?.length == null || this.$store.getters.get_Booking?.passengers?.length == 0) {
                return "";
            }

            if (this.$store.getters.get_Booking?.passengers?.length == 1) {
                return "1 <span class='text-sm'>guest</span>";
            }

            return this.$store.getters.get_Booking?.passengers?.length + " <span class='text-sm'>guests</span>";
        },
        DateTrim(date: string): string {
            while (date.includes("NaN") || date.includes("undefined") || date.includes("  ")) {
            date = date.replace("NaN", "").replace("undefined", "").replace("  ","").replace("at", "From").replace("to", "To");
            }
            // Remove seconds from times like 08:45:00 to 08:45
            date = date.replace(/(\d{2}:\d{2}):\d{2}/g, "$1");
            return date;
        },
        passenger_summary(Trip: booking_info): string {
            return Book.Passenger_Details(false, this.age_cat, Trip?.tour_id, this.$store.getters.get_Booking);
        },
        room_total(Trip: booking_info): string {
            if (this.$store.getters.get_Booking?.trips[0]?.reservation_rooms?.length == null || Trip?.reservation_rooms?.length == 0 ) {
                return "";
            }

            if (Trip?.reservation_rooms?.length == 1) {
                return "1 <span class='text-sm'>room</span>";
            }

            return this.$store.getters.get_Booking?.trips[0]?.reservation_rooms?.length + " <span class='text-sm'>rooms</span>";
        },
        room_breakdown(Trip: booking_info): { room_type: string, room_price: string }[] {
            var Room_Output: {room_type: string, room_price: string}[] = [];

            Trip?.reservation_rooms?.forEach((room: booking_trip_room )=> {
                Room_Output.push({ room_type: (room.room_type ?? ""), room_price: Currency_Services.Format_Currency(Book.getRoom_Indevidual_Price(room, Trip), this.$store.getters.get_Currency) });
            });

            return Room_Output;
        },
        // ---------- compact view ----------
        // each tour with the add-ons booked on it (same tour linking as the cart); add-ons whose tour isn't listed stand alone
        compact_groups(): { trip: booking_info, add_ons: booking_info[] }[] {
            const trips = this.get_Trips().filter(t => this.zeroPriceCheck(t));
            const is_add_on = (t: booking_info) => Book.Add_On(t, this.$store);
            const mains = trips.filter(t => !is_add_on(t));
            const main_ids = new Set(mains.map(t => t.tour_id));

            const groups = mains.map(trip => ({
                trip,
                add_ons: trips.filter(a => is_add_on(a) && Book.Add_On_Parent(a, this.$store) == trip.tour_id)
            }));
            trips.filter(a => is_add_on(a) && !main_ids.has(Book.Add_On_Parent(a, this.$store)))
                .forEach(a => groups.push({ trip: a, add_ons: [] }));

            return groups;
        },
        trip_total(Trip: booking_info): string {
            return Currency_Services.Format_Currency(Book.get_price(Trip), this.$store.getters.get_Currency);
        },
        // passengers grouped by age category and price: "2 Adults × $270" with the line total "$540"
        // (names aren't known yet at this stage: they show as placeholders like "Adult1")
        passenger_groups(Trip: booking_info): { label: string, each: string, total: string }[] {
            const booking = this.$store.getters.get_Booking;
            const currency = this.$store.getters.get_Currency;

            const groups = new Map<string, { category: string, price: number, count: number }>();

            (Trip?.passengers ?? []).forEach((passenger: client_booking) => {
                const category = Book.get_Passenger_Age_Cat(passenger.passenger_identifier, booking) || "";
                const key = category + "|" + passenger.price;
                const group = groups.get(key) ?? { category, price: passenger.price, count: 0 };
                group.count++;
                groups.set(key, group);
            });

            return Array.from(groups.values()).map(g => ({
                label: g.count + " " + this.age_category_label(g.category, g.count),
                each: g.count > 1 ? "× " + Currency_Services.Format_Currency(g.price, currency) : "",
                total: Currency_Services.Format_Currency(g.price * g.count, currency)
            }));
        },
        // "Adult" → "Adults", "Child" → "Children"; only the first word, so "Adult (18+)" → "Adults (18+)"
        age_category_label(category: string, count: number): string {
            const name = category.trim() || "Passenger";
            if (count == 1) return name;

            const [first, ...rest] = name.split(" ");
            let plural = first;
            if (/^child$/i.test(first)) plural = first.charAt(0) + "hildren";
            else if (/[^aeiou]y$/i.test(first)) plural = first.slice(0, -1) + "ies";
            else if (!/s$/i.test(first)) plural = first + "s";
            return [plural, ...rest].join(" ");
        },
        compact_dates(Trip: booking_info): string {
            // times unknown: still show the departure date
            if (this.product_check_dates(Trip)) return this.DateTrim(this.product_start_date_Only(Trip) ?? "");
            const both = this.product_start_end_date(Trip);
            if (both != "") return both;
            const start = this.product_start_date(Trip), end = this.product_end_date(Trip);
            return start && end && start != end ? start + " – " + end : start;
        },
        room_summary(Trip: booking_info): string {
            return Array.from(new Set(this.room_breakdown(Trip).map(r => r.room_type).filter(r => r != ""))).join(", ");
        },
        passenger_info(passenger: client_booking): string {
            return Book.get_Passenger(passenger.passenger_identifier, this.$store.getters.get_Booking);
        },
        passenger_price(passenger: client_booking): string {
            return Currency_Services.Format_Currency(passenger.price, this.$store.getters.get_Currency);
        },
        isAddon(Trip: booking_info): boolean {
            if (Prod.Get_Details_Sync(Trip?.tour_id, this.$store).seller_information.sales_group.products.length < 1) 
            {
                return true;
            }
            return false;
        },
        hasAddOns(): boolean {
            return this.get_Trips().some(trip => this.isAddon(trip));
        },
        zeroPriceCheck(trip: booking_info): boolean {
            if (import.meta.env.VITE_DEFAULT_SEARCH_DATE_RANGE == "true") {
                return true;
            }
            else
            {
                return Book.get_price(trip) != 0;
            }
        },
        get_total_price(): number {
            return Book.get_total_price(this.$store.getters.get_Booking, this.$store);
        },
        get_total_price_formatted(): string {
            return Currency_Services.Format_Currency(this.get_total_price(), this.$store.getters.get_Currency);
        },
        get_total_price_nett(): number {
            return Book.get_full_nett_total(this.$store.getters.get_Booking, this.$store);
        },
        get_total_price_nett_formatted(): string {
            return Currency_Services.Format_Currency(this.get_total_price_nett(), this.$store.getters.get_Currency);
        },
        get_total_price_commission(): number {
            return Book.get_full_commission_total(this.$store.getters.get_Booking, this.$store);
        },
        get_total_price_commission_formatted(): string {
            return Currency_Services.Format_Currency(this.get_total_price_commission(), this.$store.getters.get_Currency);
        },
        has_commission() : boolean {
            return this.get_total_price_commission() > 0;
        },
        isAgent_Login(): boolean {
            return this.$store.getters.get_Agent_Login?.valid_login == true;
        },
        show_commission() : boolean {
            // Nett/Commission for logged-in agents on non-AAT brands. (Was "!this.isAAT" without the call,
            // which is always false, so these lines never showed.)
            return this.has_commission() && this.isAgent_Login() && !this.isAAT();
        }
    },
    mounted() {
        this.download_passenger();
    }
})